module.exports = __webpack_public_path__ + "static/img/electronic-certificate.578d73a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/training/electronic-certificate.png
// module id = uaTQ
// module chunks = 0